// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8474) return "static/chunks/8474-3b9b92ca41b72f1f.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"277":"0e42d455a2f2aef1","6313":"f111ae783aabac32"}[chunkId] + ".js";
};